export const environment = {
  production: true,
  GATEWAY_HOST: 'https://dev.let.api-gateway.innovaweb.cl',
  // GATEWAY_HOST: 'https://autoinspeccion-gateway.let.cl', // TODO eliminar posterior a pruebas
  environment: 'development',
  push: {
    channelPrefix: 'private-let_inspeccion',
    photoAnalysisEvent: 'photo-analysis-results',
    pusherAppKey: '22f96fa504cec8c129a5',
    pusherCluster: 'mt1',
  },
  analysis: {
    // Cuánto espera la app el veredicto de una foto antes de darlo por fallido (utils/PendingDegradation.ts).
    // verify:analysis-deadline del Gateway lee esta línea y exige que el plazo del Gateway, más su margen, sea
    // menor; por eso va como entero literal, sola en su línea. verify:pending-degradation fija el valor.
    pendingTimeoutMs: 120000,
  },
  storageCheck: {
    // Cuánto espera el cierre la confirmación de S3 de que las fotos obligatorias existen (utils/StorageCheck.ts). Al
    // vencer, el cierre decide con el teléfono. Supera el plazo del Gateway hacia el Storage Manager, y
    // verify:storage-check lo exige; por eso va como entero literal, solo en su línea.
    timeoutMs: 15000,
  },
};
